export { TabsRoot as Root } from "./root/TabsRoot.mjs";
export { TabsTab as Tab } from "./tab/TabsTab.mjs";
export { TabsIndicator as Indicator } from "./indicator/TabsIndicator.mjs";
export { TabsPanel as Panel } from "./panel/TabsPanel.mjs";
export { TabsList as List } from "./list/TabsList.mjs";